export default "__VITE_ASSET__Dx1vkfgW__"